import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { BsModalRef } from "ngx-bootstrap";
import { StorageService } from '../../../../../projects/jv-common/src/lib/services/storage.service';

export interface EmailEditorData {
  title: string;
  emails: Array<string>;
}

@Component({
  selector: 'email-editor',
  templateUrl: './email-editor.component.html',
  styleUrls: ['./email-editor.component.scss']
})
export class EmailEditorComponent implements OnInit {

  @Input() data: EmailEditorData = null;

  @Output() send = new EventEmitter;

  message: string = '';

  constructor(
    private modalRef: BsModalRef,
    private storage: StorageService) {
  }

  validate(txt: string): boolean {
    return /([a-z0-9\.]+)@([a-z0-9]+)\.([a-z]+)/.exec(txt) != null;
  }

  text(): string {
    return this.data.emails.join(", ");
  }

  close() {
    this.modalRef.hide();
  }

  emit() {
    this.send.emit(this.data.emails);
    this.close();
  }

  update($event) {
    let parts: Array<string> = $event.target.value.split(',');

    this.data.emails = [];
    parts.forEach(i => {
      let test = i.trim().toLowerCase();
      if (this.validate(test)) this.data.emails.push(test);
    });

    this.message = this.data.emails.length < 1 ? '<div class="text-danger">Email không hợp lệ</div>' : '';
    $event.target.focus();
  }

  ngOnInit() {

    if (this.data == null) this.data = { title: 'Email editor', emails: [] };
    if (typeof this.data.title == "undefined" || typeof this.data.title != "string") this.data.title = "Email editor";
    if (typeof this.data.emails == "undefined" || this.data.emails == null) this.data.emails = [];


  }
}
